// @ts-ignore
export const LANGUAGE_LIST: any[] = [
  { name: 'English', lang: 'en' },
  { name: '简体中文', lang: 'zh-CN' },
  { name: '繁體中文', lang: 'zh-TW' }
]
